// Interfaces / enums
import { CustomPDFReportType } from '../enums/custom-pdf-report-type.enum';
// Constants
import { MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX, MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN, } from '../features/custom-pdf-report-modal/constants';
export const hasCorrectNumberOfComparisonSecurities = (comparisonSecurities) => {
    return (comparisonSecurities.length <= MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX &&
        comparisonSecurities.length >= MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN);
};
export const hasValidReportSecurities = (reportType, primarySecurity, secondarySecurity, comparisonSecurities) => {
    let valid;
    switch (reportType) {
        case CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW:
            valid = !!primarySecurity.securityId;
            break;
        case CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && secondarySecurity.securityId);
            break;
        case CustomPDFReportType.MULTI_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && hasCorrectNumberOfComparisonSecurities(comparisonSecurities));
            break;
        case CustomPDFReportType.PRESENTATION:
            valid = true;
            break;
        case CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON:
            valid = !!(primarySecurity.securityId && hasCorrectNumberOfComparisonSecurities(comparisonSecurities));
            break;
        case CustomPDFReportType.TEARSHEET_SINGLE_SECURITY:
            valid = !!primarySecurity.securityId;
            break;
        default:
            valid = false;
            break;
    }
    return valid;
};
export function isCustomPDFReport(report) {
    return Object.values(CustomPDFReportType).includes(report.report_type);
}
